import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, STATUS } from "@/lib/api";
import { PageTitle, Prio, StatusBadge } from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";

const FILTERS = ["", "nieuw", "inspecteren", "bezoeken", "doorgezet", "vergund", "goedgekeurd", "afgewezen", "afgehandeld"];

export default function Meldingen() {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const { data = [] } = useQuery({ queryKey: ["meldingen", status, q], queryFn: () => api.get("/meldingen", { params: { status, q } }).then((r) => r.data) });

  return (
    <div className="max-w-7xl mx-auto">
      <PageTitle eyebrow="Wijzigingsdetectie" title="Meldingen" />
      <div className="flex flex-col md:flex-row gap-3 mb-5">
        <div className="flex flex-wrap gap-1.5">
          {FILTERS.map((f) => (
            <button key={f || "all"} data-testid={`filter-status-${f || "alle"}`} onClick={() => setParams(f ? { status: f } : {})}
              className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${status === f ? "bg-blue-600 border-blue-600 text-white" : "border-slate-800 text-slate-400 hover:text-white"}`}>
              {f ? STATUS[f].label : "Alle"}
            </button>
          ))}
        </div>
        <Input data-testid="meldingen-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek adres of perceel…" className="md:ml-auto md:max-w-xs h-9 bg-slate-950 border-slate-800" />
      </div>
      <div className="border border-slate-800 rounded-lg overflow-x-auto bg-[#111827]/80">
        <table className="w-full text-sm" data-testid="meldingen-table">
          <thead className="text-left font-mono text-[10px] uppercase tracking-widest text-slate-500 border-b border-slate-800">
            <tr><th className="px-4 py-3">Adres</th><th className="px-4 py-3">Perceel</th><th className="px-4 py-3">Jaren</th><th className="px-4 py-3">AI-suggestie</th><th className="px-4 py-3">Prio</th><th className="px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {data.map((m) => {
              const o = m.objecten?.[0];
              return (
                <tr key={m.id} onClick={() => nav(`/meldingen/${m.id}`)} data-testid={`melding-row-${m.id}`} className="border-b border-slate-800/60 hover:bg-blue-600/5 cursor-pointer">
                  <td className="px-4 py-3 font-medium">{m.weergavenaam}</td>
                  <td className="px-4 py-3 font-mono text-xs text-sky-300">{m.perceel_aanduiding}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-400">{m.baseline_year}→{m.upload_id ? m.compare_label : m.compare_year}</td>
                  <td className="px-4 py-3 text-xs">{o ? <span><span className="capitalize text-amber-300">{o.type}</span> · {o.lengte_m}×{o.breedte_m} m{m.objecten.length > 1 && ` +${m.objecten.length - 1}`}</span> : <span className="text-slate-500">{m.totaal_m2} m² verschil</span>}</td>
                  <td className="px-4 py-3"><Prio value={m.prioriteit} /></td>
                  <td className="px-4 py-3"><StatusBadge status={m.status} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {data.length === 0 && <div className="p-10 text-center text-sm text-slate-500" data-testid="meldingen-empty">Geen meldingen gevonden.</div>}
      </div>
    </div>
  );
}
